import "./third-party-library-to-import/tom-select@2.3.1/tom-select.complete.min.js";

document.addEventListener('turbolinks:load', function() {
  initializeClubAutocomplete();
  initializeOfficialAutocomplete();
  initializeCustomerChangeHandler();
});

function initializeCustomerChangeHandler() {
  const customerSelect = document.getElementById('q_customer_id_eq');

  if (!customerSelect) {
    return;
  }

  // Check if already initialized to avoid duplicate handlers
  if (customerSelect.dataset.filterInitialized === 'true') {
    return;
  }
  customerSelect.dataset.filterInitialized = 'true';

  customerSelect.addEventListener('change', function() {
    const customerId = this.value;

    // Clear Club and Official autocomplete fields
    clearAutocompleteField('.club-autocomplete-select');
    clearAutocompleteField('.official-autocomplete-select');

    if (customerId) {
      // Fetch competitions and seasons for the selected customer
      fetch(`/fixtures/update_competitions_and_clubs?customer_id=${customerId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      })
      .then(response => response.json())
      .then(data => {
        updateSelectOptions('q_competition_id_eq', data.competitions);
        updateSelectOptions('q_season_id_eq', data.seasons);
      })
      .catch(error => console.error('Error fetching customer data:', error));
    } else {
      // Clear competitions and seasons if no customer selected
      clearSelectOptions('q_competition_id_eq');
      clearSelectOptions('q_season_id_eq');
    }
  });
}

function updateSelectOptions(selectId, options) {
  const select = document.getElementById(selectId);
  if (!select) return;

  // Clear existing options except the blank one
  select.innerHTML = '<option value=""></option>';

  // Add new options
  if (options && options.length) {
    options.forEach(function(option) {
      const opt = document.createElement('option');
      opt.value = option.id;
      opt.textContent = option.name;
      select.appendChild(opt);
    });
  }
}

function clearSelectOptions(selectId) {
  const select = document.getElementById(selectId);
  if (!select) return;
  select.innerHTML = '<option value=""></option>';
}

function clearAutocompleteField(selector) {
  const element = document.querySelector(selector);
  if (element && element.tomselect) {
    element.tomselect.clear();
    element.tomselect.clearOptions();
  }
}

function initializeClubAutocomplete() {
  const selectElement = document.querySelector('.club-autocomplete-select');

  if (!selectElement) {
    return;
  }

  // Skip if already initialized
  if (selectElement.tomselect) {
    return;
  }

  const isSystemAdministrator = selectElement.dataset.systemAdministrator === 'true';
  const defaultCustomerId = selectElement.dataset.customerId;

  // Remove form-control class to avoid style conflicts
  selectElement.classList.remove('form-control');

  new TomSelect(selectElement, {
    valueField: 'name',
    labelField: 'name',
    searchField: ['name'],
    create: false,
    maxItems: 1,
    load: function(query, callback) {
      if (!query.length) return callback();

      // Determine customer_id based on role
      let customerId = defaultCustomerId;
      if (isSystemAdministrator) {
        const customerSelect = document.getElementById('q_customer_id_eq');
        if (customerSelect && customerSelect.value) {
          customerId = customerSelect.value;
        }
      }

      const url = `/clubs/autocomplete_search?q=${encodeURIComponent(query)}&customer_id=${customerId}`;

      fetch(url)
        .then(response => response.json())
        .then(json => callback(json))
        .catch(() => callback());
    },
    render: {
      option: function(data, escape) {
        return '<div class="ts-club-option">' + escape(data.name) + '</div>';
      },
      item: function(data, escape) {
        return '<div>' + escape(data.name) + '</div>';
      }
    },
    onItemAdd: function(value, item) {
      this.setTextboxValue('');
    }
  });
}

function initializeOfficialAutocomplete() {
  const selectElement = document.querySelector('.official-autocomplete-select');

  if (!selectElement) {
    return;
  }

  // Skip if already initialized
  if (selectElement.tomselect) {
    return;
  }

  const isSystemAdministrator = selectElement.dataset.systemAdministrator === 'true';
  const defaultCustomerId = selectElement.dataset.customerId;

  // Remove form-control class to avoid style conflicts
  selectElement.classList.remove('form-control');

  new TomSelect(selectElement, {
    valueField: 'id',
    labelField: 'name',
    searchField: ['name'],
    create: false,
    maxItems: 1,
    load: function(query, callback) {
      if (!query.length) return callback();

      // Determine customer_id based on role
      let customerId = defaultCustomerId;
      if (isSystemAdministrator) {
        const customerSelect = document.getElementById('q_customer_id_eq');
        if (customerSelect && customerSelect.value) {
          customerId = customerSelect.value;
        }
      }

      const url = `/users/autocomplete_search?q=${encodeURIComponent(query)}&customer_id=${customerId}`;

      fetch(url)
        .then(response => response.json())
        .then(json => callback(json))
        .catch(() => callback());
    },
    render: {
      option: function(data, escape) {
        return '<div class="ts-official-option">' + escape(data.name) + '</div>';
      },
      item: function(data, escape) {
        return '<div>' + escape(data.name) + '</div>';
      }
    },
    onItemAdd: function(value, item) {
      this.setTextboxValue('');
    }
  });
}

// Export for potential external use
window.initializeClubAutocomplete = initializeClubAutocomplete;
window.initializeOfficialAutocomplete = initializeOfficialAutocomplete;
